module.exports = __webpack_public_path__ + "img/19.ae3c6891.jpg";